const mockSalesData = [];

// {id: 0, 2021:{q1: 255, q2, 123, q3: 42, q4: 97}, 2022: {q1: 25, q2, 53, q3: 122, q4: 197}}

const r = () => Math.ceil((Math.random()*200)+10)

const populate = () => {
  let i = 0;
  while(i < 33) {
    const firstQ21 = r()
    const secondQ21 = r()
    const thirdQ21 = r()
    const fourthQ21 = r()

    const firstQ22 = r()
    const secondQ22 = r()
    const thirdQ22= r()
    const fourthQ22 = r()

    let obj = {
      "id":i,
      category: i%7,
      subcategory: i%3,
      dates:{
        "2021-03-01": firstQ21, 
        "2021-06-01": secondQ21, 
        "2021-09-01": thirdQ21, 
        "2021-12-01": fourthQ21, 
        "2022-03-01": firstQ22, 
        "2022-06-01": secondQ22, 
        "2022-09-01": thirdQ22, 
        "2022-12-01": fourthQ22
      } 
    }

    mockSalesData.push(obj);

    i++
  }
}
populate();

// console.log(mockSalesData)
export default mockSalesData;